import React, { VFC, useState } from 'react';
import { TFunction } from 'react-i18next';
import { Button, Typography, makeStyles } from '@dxb-web-ui-framework/design-system';
import { GenericDialog } from '../../../content-composer/src/components/Generic/GenericDialog/GenericDialog';
import { DialogAction } from '../../../content-composer/src/components/Generic/types';

export interface RejectProps {
  t: TFunction;
  isLoading: boolean;
  onReject: React.MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles(theme => ({
  dialogContent: {
    marginBottom: theme.spacing(5),
  },
}));

const Reject: VFC<RejectProps> = ({ isLoading, onReject, t }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleDialog = () => {
    setIsOpen(prev => !prev);
  };

  const onRejectWrapper: React.MouseEventHandler<HTMLButtonElement> = e => {
    onToggleDialog();
    onReject(e);
  };

  const dialogActions: DialogAction[] = [
    {
      onClick: onToggleDialog,
      label: t('fundsTransferPage.RequestDealerRate.cancelButton.Label'),
      color: 'primary',
      variant: 'outlined',
    },
    {
      onClick: onRejectWrapper,
      label: t('fundsTransferPage.RequestDealerRate.confirmButton.Label'),
      color: 'primary',
      variant: 'contained',
    },
  ];

  const classes = useStyles();

  return (
    <>
      <Button
        onClick={onToggleDialog}
        variant='outlined'
        color='primary'
        disabled={isLoading}
        title={t('authorizationsListPage.TransactionInvolvedPartiesWithDealerRate.Reject')}>
        {t('authorizationsListPage.TransactionInvolvedPartiesWithDealerRate.Reject')}
      </Button>
      <GenericDialog
        fullwidth
        isError={false}
        isLoading={false}
        isConfirmationResponsiveDialog={true}
        dialogContentClassName={classes.dialogContent}
        isDialogOpen={isOpen}
        onToggleDialog={onToggleDialog}
        stickDrawerTitleToLeft={true}
        disableMobileDrawerHeight={true}
        dialogTitle={t('authorizationsListPage.TransactionInvolvedPartiesWithDealerRate.Drawer.Reject.Title')}
        loaderVerticalSpacing='large'
        dialogContent={
          <Typography variant='body2'>
            {t('authorizationsListPage.TransactionInvolvedPartiesWithDealerRate.Drawer.Reject.Content')}
          </Typography>
        }
        isSuccess={false}
        dialogActions={dialogActions}
      />
    </>
  );
};

export { Reject };
